import firebase from "firebase/app";
import Vue from "vue";
import Router from "vue-router";

import Informativa from "@/components/Informativa";
import PhoneAuth from "@/components/PhoneAuth";
import PatientDownload from "@/components/PatientDownload";
import Logout from "@/components/Logout";
import RegistrationUploadFile from "@/components/RegistrationUploadFile";
import PatientUpload from "@/components/PatientUpload";
import Unauthorized from "@/components/Unauthorized";
import ToViewPatientFiles from "@/components/ToViewPatientFiles";
import InsertPhone from "@/components/InsertPhone";
import NewPhone from "@/components/NewPhone";
import optionsView from "@/components/optionsView";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/informativa",
      name: "Informativa",
      component: Informativa
    },
    {
      path: "*",
      redirect: "/view-files"
    },
    {
      path: "/phone-auth",
      name: "PhoneAuth",
      component: PhoneAuth
    },
    {
      path: "/download-files",
      name: "PatientDownload",
      component: PatientDownload
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    },
    {
      path: "/unauthorized",
      name: "Unauthorized",
      component: Unauthorized
    },
    {
      path: "/patient-upload",
      name: "PatientUpload",
      component: PatientUpload
    },
    {
      path: "/registration-upload",
      name: "RegistrationUploadFile",
      component: RegistrationUploadFile
    },
    {
      path: "/registration-phone",
      name: "InsertPhone",
      component: InsertPhone
    },
    {
      path: "/new-phone",
      name: "NewPhone",
      component: NewPhone
    },
    {
      path: "/view-files",
      name: "ToViewPatientFiles",
      component: ToViewPatientFiles
    },
    {
      path: "/act-options",
      name: "optionsView",
      component: optionsView
    }
  ]
});

/*router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login');
  else if (!requiresAuth && currentUser) next('home');
  else next();
});*/

export default router;



// WEBPACK FOOTER //
// ./src/plugins/router/index.js